import { render, staticRenderFns } from "./employee-details.vue?vue&type=template&id=b1009e06&"
import script from "./employee-details.component.ts?vue&type=script&lang=ts&"
export * from "./employee-details.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports